(() => {
  if (customElements.get('ugc-grid')) return;

  class UgcGrid extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.toggle = this.querySelector('[data-ugc-toggle]');
      this.visible = new Set();
      const reduced = window.theme?.motion ? window.theme.motion() === 'off' : false;
      this.paused = window.theme?.canAutoplayVideo ? !window.theme.canAutoplayVideo() : reduced;
      this.videos.forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
      });
      this.toggle?.addEventListener('click', () => this.setPaused(!this.paused));
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.visible.add(entry.target);
            else this.visible.delete(entry.target);
          });
          this.sync();
        }, { rootMargin: '200px 0px' });
        this.videos.forEach((video) => this.observer.observe(video));
      } else {
        this.videos.forEach((video) => this.visible.add(video));
      }
      this.setPaused(this.paused);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    setPaused(paused) {
      this.paused = paused;
      this.toggle?.setAttribute('aria-pressed', String(paused));
      this.sync();
    }

    sync() {
      this.videos.forEach((video) => {
        if (this.paused || !this.visible.has(video)) {
          video.pause();
          return;
        }
        if (window.theme?.playVideo) {
          window.theme.playVideo(video);
          return;
        }
        const attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(() => {});
      });
    }
  }

  customElements.define('ugc-grid', UgcGrid);
})();
